module.exports = __webpack_public_path__ + "media/images/icon__minus-804d7dce0bf9dd2348fd5548fa486c90.png";